import { makeClassName } from '@siteless/util';
import React from 'react';

type InputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> & {
  onChange: (value: string) => void;
  stacked?: boolean;
};

const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  onChange,
  value,
  disabled = false,
  className = '',
  stacked,
  type = 'text',
  ...rest
}, ref) => (
  <input
    ref={ref}
    className={makeClassName(
      'Input focus:border-rose-bright rounded-xl border-4 border-neutral-200',
      className,
      stacked && '--stacked',
    )}
    type={type}
    onChange={event => {
      const value = event.target.value;
      onChange(value);
    }}
    spellCheck={false}
    value={value}
    {...rest}
  />
));

export default Input;
